module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Possibly following generations in seafaring, but seasickness interrupted, rock stardom called, but hung up. University in Trinity College Dublin did call and the love of story overtook, followed by adventures in the US and UK. A few books later, and a curious stumble into interior design, Declan J. S. Moloney is back in his happy place of imagination and a story to share.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0